import React from 'react';
import clsx from 'clsx';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, Navigation } from 'swiper/modules';

import Container from '@common/Container';
import Heading from '@common/Heading';
import Section from '@common/Section';
import Img from '@common/Image';
import Link from '@common/Link';

const LinksCarousel = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
      <Container className='position-relative'>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        {list &&
          <Swiper
            className='col-lg-10 links-swiper'
            modules={[A11y, Navigation]}
            slidesPerView={1.5}
            slidesPerGroup={1}
            spaceBetween={20}
            navigation={true}
            loop
            breakpoints={{
            1200: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              spaceBetween: 20
            },
            992: {
              slidesPerView: 2.5,
              slidesPerGroup: 2,
              spaceBetween: 20
            },
            768: {
              slidesPerView: 1.75,
              slidesPerGroup: 1,
              spaceBetween: 20
            }
            }}>
            {list.map((card, index) => (
              <SwiperSlide key={index} className='d-flex flex-column'>
                <Link to={card.link} className='text-black'>
                  {card.image &&
                  <div className='position-relative mb-3 rounded'>
                    <Img
                      placeholder='blurred'
                      image={card.image.gatsbyImageData}
                      file={card.image.file}
                      alt={card.image.description}
                    />
                    <div className={clsx('position-absolute text-uppercase fs-14 rounded', {[`bg-${card.bgColour}`]:card.bgColour})} style={{top: 10, right: 10, padding: '2px 5px'}}>
                      {card.subtitle}
                    </div>
                  </div>
                    
                  }
                  <p>{card.title}</p>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
        }
      </Container>
    </Section>
  )
}

export default LinksCarousel
